import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';
import aceptadas from '../../img/aceptadas.png';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { obtenerSolicitudesWithStatus } from '../../redux/SolicitudesDucks';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black'
};
const ModalReutilizable = (props) => {

    const currentUser = useSelector(store => store.Usuario.data)
    const dispatch = useDispatch()
    /******Modal */
    const [openModal, setOpenModal] = React.useState(true);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const {folioSolicitud = ''} = props
    // const handleOpenModal = (data) => {
    //     setTitleModal(data.title)
    //     setBodyModal(data.body)
    //     setAccion(data.accion)
    //     setOpenModal(true)
    // }
    const handleCloseModal = async () => {
        //await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: currentUser.user[0].id }))
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        //props.history.push('/solicitudes')
    }
    React.useEffect(() => {
        setOpenModal(props?.location?.state?.modal);
    }, [props])
    return (
        <div>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707", textAlign: 'center' }}>
                        {props?.location?.state?.titulo}
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify' }}>
                        <strong>{` ${props?.location?.state?.mensaje} `}</strong>
                    </Typography>
                    <br />
                    
                        <div className='text-center'>
                            <button className={`btn btn-success`} type='button' style={{ width: '100%' }} onClick={() => handleCloseModal()}>Aceptar</button>
                        </div>
                </Box>
            </Modal>
        </div>
    )
};

export default withRouter(ModalReutilizable)
